<template>
   <!-- 全屏遮罩 -->
    <div class = "fullscreen"   v-loading="isFullscreen"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :style="isFullscreen?'':'display:none'">
    </div>
</template>
<script>
export default {
  name:"fullscreen",//全屏遮罩组件
  props:{
    isFullscreen:{
      type:Boolean,
      default:false,
    },
    loadingText:{
      type:String,
      default:"读取中..."
    }
  }
}
</script>
<style scoped>
  .fullscreen{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999;
}
</style>




// WEBPACK FOOTER //
// fullscreen.vue?d9c6cd60